"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Make sure the given `Dateable` is a `Date`.
 *
 * @param {Dateable} date
 */
const ensureDate = (date) => {
    // The server sends us UNIX timestamps in seconds, make sure we use JS timestamp in milliseconds
    if (typeof date === 'number' && date < 10e9) {
        date *= 1000;
    }
    return new Date(date);
};
exports.default = ensureDate;
